import { Component, input, output, Renderer2 } from '@angular/core';
import { LiteralService, UtilsService } from 'src/app/services';

@Component({
  selector: 'app-option-selector',
  templateUrl: './option-selector.component.html',
  styleUrl: './option-selector.component.scss',
  standalone: false
})
export class OptionSelectorComponent {

  readonly id = input<string>();
  readonly componentOpen = input<string>();
  readonly options = input<any>();
  readonly selectedOption = input<any>();
  readonly title = input<string>('');
  readonly onChange = output<any>();
  readonly close = output<void>();

  constructor(
    renderer: Renderer2,
    public utilsService: UtilsService,
    public literalService: LiteralService
  ) {
    renderer.listen('window', 'click', (e: Event) => {
      const modal = document.getElementById(this.id()!);
      const componentOpen = document.getElementById(this.componentOpen()!)!;
      const close = utilsService.closeCustomModals(e, modal!, componentOpen);
      if (close) {
        this.close.emit();
      }
    });
  }

  selectValue(value: any) {
    this.onChange.emit(value);
  }
}
